import React, { useState } from "react";
import axios from "axios";

import "../publicUsersPages/Payments.css";

const PaymentPage = () => {
  const [loading, setLoading] = useState(false);

  const createOrder = async () => {
    try {
      setLoading(true);

      const request = {
        bookingId: 47,

        userId: 1,

        amount: 7000,
      };

      const response = await axios.post(
        "http://localhost:9777/v2/payment/create-order",
        request,
      );

      if (response.data.statusCode !== 200) {
        alert(response.data.message);
        setLoading(false);
        return;
      }

      openCheckout(response.data.data);
    } catch (error) {
      console.log(error);

      alert("Unable to create payment order");

      setLoading(false);
    }
  };

  const openCheckout = (payment) => {
    const options = {
      key: payment.key,

      amount: payment.amount,

      currency: payment.currency,

      order_id: payment.orderId,

      name: "SVK PG",

      description: "PG Room Booking",

      image: "",

      handler: async function (response) {
        console.log("Payment Success");

        console.log(response);

        await verifyPayment(response);
      },

      prefill: {
        name: "Madhu",

        email: "madhu@gmail.com",

        contact: "9876543210",
      },

      notes: {
        bookingId: 47,
      },

      theme: {
        color: "#3399cc",
      },

      modal: {
        ondismiss: function () {
          alert("Payment Cancelled");
        },
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.open();

    setLoading(false);
  };

  const verifyPayment = async (paymentResponse) => {
    try {
      const request = {
        razorpayOrderId: paymentResponse.razorpay_order_id,

        razorpayPaymentId: paymentResponse.razorpay_payment_id,

        razorpaySignature: paymentResponse.razorpay_signature,
      };

      const response = await axios.post(
        "http://localhost:9777/v2/payment/verify",

        request,
      );

      console.log(response.data);

      if (response.data.statusCode === 200) {
        alert("Payment Successful");
      } else {
        alert("Payment Verification Failed");
      }
    } catch (error) {
      console.log(error);

      alert("Verification Failed");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <button
        onClick={createOrder}
        disabled={loading}
        style={{
          background: "#3399cc",

          color: "white",

          border: "none",

          padding: "15px 30px",

          borderRadius: "8px",

          cursor: "pointer",

          fontSize: "18px",
        }}
      >
        {loading ? "Please Wait..." : "Pay ₹7000"}
      </button>
    </div>
  );
};

export default PaymentPage;
